import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// withCredentials is NOT used because Emergent platform ingress hard-codes
// Access-Control-Allow-Origin: * which is incompatible with credentials.
// We use Bearer token auth (localStorage) instead.
export const api = axios.create({ baseURL: API });

export const setUserToken = (token) => {
  if (token) {
    localStorage.setItem("c4t_user_token", token);
  } else {
    localStorage.removeItem("c4t_user_token");
  }
};

// Attach the appropriate Authorization header per-request.
// Admin token takes precedence on /admin/* endpoints; otherwise user session token is sent.
api.interceptors.request.use((config) => {
  const url = (config.url || "");
  const adminToken = localStorage.getItem("c4t_admin_token");
  const userToken = localStorage.getItem("c4t_user_token");
  if (url.startsWith("/admin/") && adminToken) {
    config.headers["Authorization"] = `Bearer ${adminToken}`;
  } else if (userToken) {
    config.headers["Authorization"] = `Bearer ${userToken}`;
  }
  return config;
});

export const setAdminToken = (token) => {
  if (token) {
    localStorage.setItem("c4t_admin_token", token);
  } else {
    localStorage.removeItem("c4t_admin_token");
  }
};

export const LOGO_URL = "https://customer-assets.emergentagent.com/job_93846003-fe21-4590-958d-9bbd47da4fce/artifacts/z3ais8sg_image.png";
